import React, { useState, useCallback, useRef } from 'react';
import { Analytics } from '@vercel/analytics/react';
import Timeline from './components/Timeline';
import SearchBar from './components/SearchBar';
import DownloadButton from './components/DownloadButton';
import MobileDropdown from './components/MobileDropdown';
import BackToTop from './components/BackToTop';
import './App.css';

function App() {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState({ total: 0, current: 0 });
  const [timelineData, setTimelineData] = useState([]);
  const navigateRef = useRef(null);

  const handleSearch = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  const handleSearchResults = useCallback((results) => {
    setSearchResults(results);
  }, []);

  const handleNavigate = useCallback((direction) => {
    if (navigateRef.current) {
      navigateRef.current(direction);
    }
  }, []);

  const handleDataChange = useCallback((data) => {
    setTimelineData(data);
  }, []);

  return (
    <div className="App">
      <div className="logo-container">
        <a 
          href="https://www.evrim.ai/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="logo-link"
        >
          <img src="/evrim-logo.svg" alt="Evrim Logo" className="evrim-logo" />
        </a>
      </div>
      
      {/* Desktop/Tablet Search and Download */}
      <div className="search-container desktop-search">
        <SearchBar 
          onSearch={handleSearch} 
          onNavigate={handleNavigate}
          currentMatch={searchResults.current}
          totalMatches={searchResults.total}
        />
        <DownloadButton timelineData={timelineData} />
      </div>
      
      {/* Mobile Dropdown */}
      <MobileDropdown 
        onSearch={handleSearch}
        onNavigate={handleNavigate}
        currentMatch={searchResults.current}
        totalMatches={searchResults.total}
        timelineData={timelineData}
      />
      
      <main>
        <Timeline 
          searchTerm={searchTerm} 
          onSearchResults={handleSearchResults}
          navigateRef={navigateRef}
          onDataChange={handleDataChange}
        />
      </main>
      <BackToTop />
      <Analytics />
    </div>
  );
}

export default App;
